import * as React from 'react';
import {useMemo} from 'react';
import {Card} from 'semantic-ui-react';
import {labelComponent, makeCaptions} from '../util/media';
import makeComp from '../util/profiler';
import {runLink} from '../util/runhelpers';
import {Struct} from '../util/types';
import {getObject3DMediaPath, MediaCardProps} from './MediaCard';
import MessageMediaNotFound from './MessageMediaNotFound';
import PointCloud from './PointCloud';
import Viewer3D from './Viewer3D';

export const Object3DCard: React.FunctionComponent<MediaCardProps> = makeComp(
  props => {
    const {
      run,
      globalStep,
      mediaKey,
      mediaIndex,
      runSignature,
      height,
      width,
      tileMedia,
    } = props;

    const mediaPath =
      getObject3DMediaPath(
        {historyRow: tileMedia?.historyRow, mediaKey},
        mediaIndex
      ) ?? '';

    const isPointCloud = mediaPath.slice(-9) === '.pts.json';
    const Media3DComponent = isPointCloud ? PointCloud : Viewer3D;

    const currentMediaMetadata: Struct | undefined =
      tileMedia?.historyRow?.[mediaKey];
    const showMetadataInline = width > 100; // if this is false, metadata will appear in a popup on the image

    const titleLink = runLink(runSignature, run.displayName, {
      className: 'hide-in-run-page',
      target: '_blank',
      rel: 'noopener noreferrer',
    });

    const captions = useMemo(() => {
      return makeCaptions(currentMediaMetadata, mediaIndex);
    }, [currentMediaMetadata, mediaIndex]);

    return (
      <Card className="object3D-card" style={{width}}>
        {labelComponent(props, tileMedia?.step, titleLink)}

        {tileMedia == null ? (
          <MessageMediaNotFound
            mediaKey={mediaKey}
            stepIndex={globalStep}
            mediaIndex={mediaIndex}
            mediaType="object3D"
          />
        ) : (
          <div
            style={{
              width,
              height,
            }}>
            <Media3DComponent
              width={width}
              height={height}
              url={tileMedia.directURL}
              blob={tileMedia.blob}
              controls={props.controls}
            />
          </div>
        )}
        {/* CAPTIONS */}
        {showMetadataInline && captions.length > 0 && (
          <div className="image-card-caption">{captions}</div>
        )}
      </Card>
    );
  },
  {id: 'Object3DCard', memo: true}
);

export default Object3DCard;
